import React, { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useUtilitiesTable from "../../useUtilitiesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddUtilitiesDialog from "./AddUtilitiesDialog.js";
import EditUtilitiesDialog from "./EditUtilitiesDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { compte } from "variables/patrimoine.js";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { updateAccountContract } from "services/ConfigServices";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const useStyles2 = makeStyles((theme) => ({
  root: {
    margin: "0 0 0 -8px",
    "& > *": {
      margin: '8px',
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ExpandableComponent = props => {
  const { data, energy, parameters } = props;
  const [value, setValue] = useState(0);

  const classes = useStyles2();

  function handleSubMenuChange(value) {
    setValue(value);
  }

  const SubTabs = () => {

      return (
        <>
        <div>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].contractnumber} : </ElementTitle>
            <ElementData>{data.details.contractnumber}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].billowner} : </ElementTitle>
            <ElementData>{data.details.billowner}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].contractowner} : </ElementTitle>
            <ElementData>{data.details.contractowner}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].payedby} : </ElementTitle>
            <ElementData>{data.details.payedby}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].contractbegindate} : </ElementTitle>
            <ElementData>{data.details.contractbegindate}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].contractenddate} : </ElementTitle>
            <ElementData>{data.details.contractenddate}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].primaryfinalenergyratio} : </ElementTitle>
            <ElementData>{data.details.primaryfinalenergyratio}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].co2ratio} : </ElementTitle>
            <ElementData>{data.details.co2ratio}</ElementData>
          </ExpandableElement>

          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].energycost} : </ElementTitle>
            <ElementData>{data.details.energycost}</ElementData>
          </ExpandableElement>
          
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].othermonthlycost} : </ElementTitle>
            <ElementData>{data.details.othermonthlycost}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].otherunitcost} : </ElementTitle>
            <ElementData>{data.details.otherunitcost}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
            <ElementData>{data.details.associatedfiles}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
            <ElementData>{data.details.comments}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
            <ElementData>{data.details.description}</ElementData>
          </ExpandableElement>
        </div>
        </>
  
      );

  };

  return (
    <Container>
      <ExpandableContainer>
        <div>
          <SubTabs />
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const Utilities = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { energy, parameters } = props;
  const {
    gridState,
    error,
    refetch,
    invalidate,
    handleClose,
  } = useUtilitiesTable(
    energy,
    parameters,
    <AddUtilitiesDialog
      energy={energy}
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refetch()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouveau fournisseur",
    "Ajout d'un fournisseur",
    "Liste fournisseurs"
  );
  const [deleteCounter, setDeleteCounter] = useState(0);

  const [open, setOpen] = useState(false);

  const [clef, setClef] = useState();
  const [contractname, setContractname] = useState();
  const [contractnumber, setContractnumber] = useState();
  const [tarifftype, setTarifftype] = useState();
  const [name, setName] = useState();
  const [contractbegindate, setContractbegindate] = useState();
  const [contractenddate, setContractenddate] = useState();
  const [billowner, setBillowner] = useState();
  const [contractowner, setContractowner] = useState();
  const [payedby, setPayedby] = useState();
  const [primaryfinalenergyratio, setPrimaryfinalenergyratio] = useState();
  const [co2ratio, setCo2ratio] = useState();
  const [energycost, setEnergycost] = useState();
  const [othermonthlycost, setOthermonthlycost] = useState();
  const [otherunitcost, setOtherunitcost] = useState();
  const [comments, setComments] = useState();
  const [description, setDescription] = useState();
  const [ged, setGed] = useState([]);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };
  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleContractnameChange = (e) => {
    setContractname(e.target.value);
  };
  const handleContractnumberChange = (e) => {
    setContractnumber(e.target.value);
  };
  const handleTariftypeChange = (e) => {
    setTarifftype(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleContractbegindateChange = (e) => {
    setContractbegindate(e.target.value);
  };
  const handleContractenddateChange = (e) => {
    setContractenddate(e.target.value);
  };
  const handleBillownerChange = (e) => {
    setBillowner(e.target.value);
  };
  const handleContractownerChange = (e) => {
    setContractowner(e.target.value);
  };
  const handlePayedbyChange = (e) => {
    setPayedby(e.target.value);
  };
  const handlePrimaryfinalenergyratioChange = (e) => {
    setPrimaryfinalenergyratio(e.target.value);
  };
  const handleCo2ratioChange = (e) => {
    setCo2ratio(e.target.value);
  };
  const handleEnergycostChange = (e) => {
    setEnergycost(e.target.value);
  };

  const handleOthermonthlycostChange = (e) => {
    setOthermonthlycost(e.target.value);
  };
  const handleOtherunitcostChange = (e) => {
    setOtherunitcost(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setGed(newValue);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: compte.energy[energy][parameters].key,
      selector: row => row.details.clef,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].contractname,
      selector: row => row.details.contractname,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].tarifftype,
      selector: row => row.details.tarifftype,
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].name,
      selector: row => row.details.name,
      sortable: true,
      maxWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">{row.details.name}</div>
        </>
      ),
    },
    realestateupdate ? 
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editUser(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression du fournisseur"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer le fournisseur ?"
              }
              handleSupprimer={deleteUtility(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  const [idSelected, setIdSelected] = useState();

  const editUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);

    handleClickOpen();

    setIdSelected(obj.uuid);
    setClef(obj.details.clef);
    setContractname(obj.details.contractname);
    setContractnumber(obj.details.contractnumber);
    setTarifftype(obj.details.tarifftype);
    setName(obj.details.name);
    setContractbegindate(obj.details.contractbegindate);
    setContractenddate(obj.details.contractenddate);
    setBillowner(obj.details.billowner);
    setContractowner(obj.details.contractowner);
    setPayedby(obj.details.payedby);
    setPrimaryfinalenergyratio(obj.details.primaryfinalenergyratio);
    setCo2ratio(obj.details.co2ratio);
    setEnergycost(obj.details.energycost);
    setOthermonthlycost(obj.details.othermonthlycost);
    setOtherunitcost(obj.details.otherunitcost);
    setGed(obj.details.ged);
    setComments(obj.details.comments);
    setDescription(obj.details.description);
  };

  const deleteUtility = (row) => async () => {
    axios
      .delete(
        updateAccountContract(row.uuid, chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then(() => {
        refetch();
      })
      .catch(() => { });
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          expandableRowsComponentProps={{energy,parameters}}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier le fournisseur
          </DialogTitle>
          <DialogContent dividers>
            <EditUtilitiesDialog
              energy={energy}
              parameters={parameters}
              closeModal={handleEditClose}
              refetch={refetch}
              idSelected={idSelected}
              clef={clef}
              contractname={contractname}
              contractnumber={contractnumber}
              tarifftype={tarifftype}
              name={name}
              contractbegindate={contractbegindate}
              contractenddate={contractenddate}
              billowner={billowner}
              contractowner={contractowner}
              payedby={payedby}
              primaryfinalenergyratio={primaryfinalenergyratio}
              co2ratio={co2ratio}
              energycost={energycost}
              othermonthlycost={othermonthlycost}
              otherunitcost={otherunitcost}
              comments={comments}
              description={description}
              ged={ged}
              handleContractnameChange={handleContractnameChange}
              handleContractnumberChange={handleContractnumberChange}
              handleTariftypeChange={handleTariftypeChange}
              handleContractbegindateChange={handleContractbegindateChange}
              handleContractenddateChange={handleContractenddateChange}
              handleBillownerChange={handleBillownerChange}
              handleContractownerChange={handleContractownerChange}
              handlePayedbyChange={handlePayedbyChange}
              handlePrimaryfinalenergyratioChange={
                handlePrimaryfinalenergyratioChange
              }
              handleCo2ratioChange={handleCo2ratioChange}
              handleEnergycostChange={handleEnergycostChange}
              handleOthermonthlycostChange={handleOthermonthlycostChange}
              handleOtherunitcostChange={handleOtherunitcostChange}
              handleAssociatedfilesChange={handleAssociatedfilesChange}
              handleCommentsChange={handleCommentsChange}
              handleDescriptionChange={handleDescriptionChange}
              handleClefChange={handleClefChange}
              handleNameChange={handleNameChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Utilities;
